import { getClosingDate } from '@/utils/closing-date';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/_layout/')({
  component: App,
  beforeLoad:  async () =>  {
    const closingDate = getClosingDate()
    throw redirect({ to: '/summary', search: { month: closingDate.month, year: closingDate.year, source:'personal' } });
  }
  
})

function App() {
  return (
    <div className="text-center">
      Welcome to Closing Dashboard GBS
    </div>
  )
}
